<script>
const set = function(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  window.document.cookie =
    name + "=" + value + ";path=/;expires=" + d.toGMTString();
};

const get = function(name) {
  const v = window.document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
};

const del = function(name) {
  this.set(name, "", -1);
};

const clear = function() {
  this.set("loggedId", "", -1);
  this.set("loggedName", "", -1);
  this.set("loggedRole", "", -1);
};

export default {
  set,
  get,
  del,
  clear
};
</script>

